<div
  class="tab-pane engine__tab-pane fade show active"
  id="cruises"
  role="tabpanel"
  aria-labelledby="cruises-tab"
>
  <form class="search-from" name="cruise">
    <div class="search-form__engine">
      <div
        class="search-form__modal search-form__element"
        [ngClass]="{ disabled: !(cruisePrefetch$ | async) }"
      >
        <app-engine-cruise-modal-itineraries
          (click)="onInputSelection()"
          [defaultItinerary]="cruiseSearchParams?.destinations"
          [cruisePrefetch$]="cruisePrefetch$"
          (selectedItinerary)="onSelectedItinerary($event)"
        ></app-engine-cruise-modal-itineraries>
      </div>
      <div class="search-form__select search-form__element">
        <app-engine-cruise-select-date
          [defaultDate]="cruiseSearchParams?.from"
          [cruisePrefetch$]="cruisePrefetch$"
          (selectedDate)="onSelectedDate($event)"
        ></app-engine-cruise-select-date>
      </div>
      <div class="search-form__select search-form__element">
        <app-engine-cruise-select-harbour
          [defaultHarbour]="cruiseSearchParams?.harbours"
          [cruisePrefetch$]="cruisePrefetch$"
          (selectedHarbour)="onSelectedHarbour($event)"
        ></app-engine-cruise-select-harbour>
      </div>
      <div class="search-form__select search-form__element">
        <app-engine-cruise-select-ship
          [defaultShip]="cruiseSearchParams?.ships"
          [cruisePrefetch$]="cruisePrefetch$"
          (selectedShip)="onSelectedShip($event)"
        ></app-engine-cruise-select-ship>
      </div>
      <button
        [disabled]="!selectedItinerary || !selectedMonth"
        (click)="searchCruise()"
        class="search-form__cta search-form__element btn btn--sm btn--brand-color-03 btn__uppercase mt-3"
      >
        Cerca <i class="icon-search"></i>
      </button>
    </div>
  </form>
</div>
